module.exports = __webpack_public_path__ + "static/media/upload.ec6fb4e7.png";